import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import TwitterIcon from '@material-ui/icons/Twitter';
import TwitterXIcon from '../util/TwitterX';


import { useMatomo } from '@datapunt/matomo-tracker-react'

import L from "../util/L10n";
import EntryUrl from '../util/EntryUrl';
import InvisibleImg from '../a11y/InvisibleImg';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        padding: 0,
        marginLeft: -10,
    },
    twitterIcon: {
        fontSize: 40,
        transform: 'scale(0.643)',
        color: '#ffffff',
        backgroundColor: '#000000',
        borderRadius: 8,
        padding: 8,
    },
}));

class ShareTwitterButton extends PureComponent {
    render() {
        const { classes, userLang, entry, trackShare } = this.props;
        const url = EntryUrl.getUrl(entry);
        const params = { url };
        const text = L.t('shareTwitterText', userLang, params);
        const href = 'https://twitter.com/intent/tweet?text=' +
            encodeURIComponent(text) + '&url=' + encodeURIComponent(url);
        const altText = L.t('shareTwitterAlt', userLang);
        return (
            <IconButton
                className={classes.iconButton}
                component='a'
                href={href}
                target='_blank'
                rel='noopener'
                onClick={() => {
                    trackShare(url);
                }}
            >
                <TwitterXIcon
                    className={classes.twitterIcon}
                />
                <InvisibleImg
                    alt={altText}
                />
            </IconButton>
        );
    }
}

ShareTwitterButton.propTypes = {
    classes: PropTypes.object,
    entry: PropTypes.object,
    trackShare: PropTypes.func,
    userLang: PropTypes.string,
};

export default function _ShareTwitterButton(props) {
    const classes = useStyles();
    const { trackEvent } = useMatomo();
    const onShare = (url) => {
        trackEvent({
            category: 'share',
            action: 'twitter',
            name: url,
        });
        return true;
    };
    return (
        <ShareTwitterButton
            {...props}
            classes={classes}
            trackShare={onShare}
        />
    );
}
